/*=========================================================================================
  File Name: state.js
  Description: Order Manager Getters
  ----------------------------------------------------------------------------------------
  Item Name: Order Manager State Module
  Author: Tan Tran
==========================================================================================*/
import Fuse from 'fuse.js'
import Moment from 'moment'
export default {
    totalOrders : state => {
      return state.orders.length;
    },

    totalInprogressOrders : state => {
      let count = 0;
      state.orders.forEach(o => {
        if(o.state === 1 && o.status === 0) {
          count++;
        }
      });
      return count;
    },

    totalPendingOrders : state => {
      let count = 0;
      state.orders.forEach(o => {
        if(o.state === 0 && o.status === 0) {
          count++;
        }
      });
      return count;
    },

    totalScheduledOrders : state => {
      let count = 0;
      state.orders.forEach(o => {
        if(o.state === 2 && o.status === 0) {
          count++;
        }
      });
      return count;
    },

    totalUnmanagedOrders : state => {
      let count = 0;
      state.orders.forEach(o => {
        if(o.state === 4 && o.status === 0) {
          count++;
        }
      });
      return count;
    },

    totalCancelledOrders : state => {
      let count = 0;
      state.orders.forEach(o => {
        if(o.status === 1) {
          count++;
        }
      });
      return count;
    },

    totalReadyOrders : state => {
      let count = 0;
      state.orders.forEach(o => {
        if(o.state === 3 && o.status === 0) {
          count++;
        }
      });
      return count;
    },

    inprogressOrders : state => {
      return state.orders.filter((e) => {
        return (e.state === 1 && e.status === 0)
      });
    },

    pendingOrders : state => {
      return state.orders.filter((e) => {
        return (e.state === 0 && e.status === 0)
      });
    },

    scheduledOrders : state => {
      return state.orders.filter((e) => {
        return (e.state === 2 && e.status === 0)
      });
    },

    readyOrders : state => {
      return state.orders.filter((e) => {
        return e.state === 3 || e.state === 5
      });
    },
    
    unmanagedOrders : state => {
      return state.orders.filter((e) => {
        return (e.state === 4 && e.status === 0)
      });
    },

    cancelledOrders : state => {
      return state.orders.filter((e) => {
        return (e.status == 1)
      });
    },

    progress : state => {
      let pending = 0;
      let inprogress = 0;
      let scheduled = 0;
      let ready = 0;
      state.orders.forEach(o => {
        if (o.state == 0 && o.status === 0) { //pending
          pending++;
        }
        else if(o.state == 1 && o.status === 0) { //inprogress
          inprogress++;
        }
        else if(o.state == 2 && o.status === 0) { //scheduled
          scheduled++;
        }
        else if (o.state == 3 && o.status === 0) { //ready
          ready++;
        }
      });

      let sumOfOrders = inprogress + pending + scheduled + ready;
      let progress = 100;
      if (sumOfOrders > 0) {
        progress = Math.ceil((ready / sumOfOrders) * 100);
      }
      else {
        progress = 100;
      }

      return progress;
    },

    unmanagedProgress : state => {
      let ready = 0;
      let unmanaged = 0;
      state.orders.forEach(o => {
        if (o.state == 4 && o.status === 0) { //unmanaged
          unmanaged++;
        }
        else if (o.state == 3 && o.status === 0) { //ready
          ready++;
        }
      });
      let sumOfOrders = ready + unmanaged;
      let progress = 100;
      if(sumOfOrders > 0) {
        progress = Math.ceil((ready / sumOfOrders) * 100);
      }
      return progress;
    },

    orderedByWebApp : state => {
      let count = 0;
      state.orders.forEach(o => {
        if(o.orderedBy === 'WebApp') {
          count++;
        }
      });
      return count; 
    },

    orderedByPhone : state => {
      let count = 0;
      state.orders.forEach(o => {
        if(o.orderedBy === 'Phone') {
          count++;
        }
      });
      return count; 
    },
 
    ordersByPickupNumberOrCustomerName : state => query => {
      let options = {
        includeScore : true,
        keys: [
          {name : 'pickupNumber', weight : 10}, 
          {name : 'customerName', weight : 1.5},
          {name : 'phoneNumber', weight : 10}],

      };

      let fuse = new Fuse(state.orders, options);
        
      let result = fuse.search(query);
      console.log(result)
      //let result = fuse.search(query).filter(o => {return o.});
      let orders = [];
      for(let i = 0; i < result.length && i < 5; i++) {
        orders.push(result[i].item);
      }
      
      return orders;
    },

    totalOrdersByTime : (state, getters, rootState) => {
      console.log('totalOrdersByTime');
      let data = [];
      let from = rootState.openingHours.fromTime.hours();
      let to = rootState.openingHours.toTime.hours();
      
      for (let i=from; i <=to; i++) {
        let orders = state.orders.filter(e => {
          //console.log('hours from order:' + Moment(e.createdDate))
          if (Moment(e.createdDate).hours() === i) {
            return true;
          }
          return false;
        });
        //console.log('hours : ' + i + ' - count: ' + orders.length)
        
        data.push(orders.length);
      }
      //console.log(data)
      return data;
    },

    orderById : state => id => {
      return state.orders.find(order => order.orderId === id);
    },


    canBeReady : state => id => {
      let index = state.orders.findIndex(order => order.orderId === id);
      console.log(index)
      if(index > -1) {
        if(state.orders[index].asap) {
          return true;
        }
        else {
          let now = Moment();
          let earliestPickupTime = Moment(state.orders[index].pickupTime, 'HH:mm:ss');
          let minutesFromEarliest = (earliestPickupTime.minutes() + (earliestPickupTime.hours() * 60)) - 10;
          let minutesFromNow = now.minutes() + (now.hours() * 60)
          let result = minutesFromNow - minutesFromEarliest;
          console.log('minutesFromEarliest : ' + minutesFromEarliest)
          console.log('minutesFromNow : ' + minutesFromNow)
          console.log(result)
          return (result >= 0)
        }
      }

      return false;

    },

    salesByApp: state => {
      let total = 0.0;
      state.orders.forEach(o => {
        if (o.orderedBy === 'WebApp') {
          total += o.amount;
        }
      });
      return (total / 100.0);

    },

    salesByPhone : state => {
      let total = 0.0;
      state.orders.forEach(o => {
        if (o.orderedBy === 'Phone') {
          total += o.amount;
        }
      });
      return total;
    },

    salesByProduct : state => {
      //
      //flatten order details
      //
      let items = []
      state.orders.forEach(o => {
        o.orderDetails.forEach(i => {
          items.push(i)
        })

      });

      //console.log(items)
      let result = [];
      let groupByProduct = items.reduce((acc, currentValue) => {
        if(!acc[currentValue.itemName]) {
          let value = {
            itemName : currentValue.itemName,
            quantity : currentValue.quantity,
            itemPrice : currentValue.itemPrice,
            discount : currentValue.discount
          }
          acc[currentValue.itemName] = value;
          result.push(acc[currentValue.itemName])
        }
        acc[currentValue.itemName].quantity += currentValue.quantity;
        return acc;
      }, {});

      return result;

    }   

    

   
}